import { render, staticRenderFns } from "./BrandAdd.vue?vue&type=template&id=96bf3760"
import script from "./BrandAdd.vue?vue&type=script&lang=js"
export * from "./BrandAdd.vue?vue&type=script&lang=js"
import style0 from "./BrandAdd.vue?vue&type=style&index=0&id=96bf3760&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports